<div *ngIf="hideMapView" class="main-header">
  <ng-container *ngTemplateOutlet="logo"></ng-container>
</div>
<div class="map-side-pan-container" *ngIf="!hideMapView && !isDispatchNotFound && !isLoading">
  <div class="main-header mobile-header">
    <ng-container *ngTemplateOutlet="logo"></ng-container>
    <ng-container *ngTemplateOutlet="shareBtn"></ng-container>
  </div>
  <div *ngIf="dispatchDetails" [style.top.px]="currentTopPosition" [class.expanded]="isDispatchExpanded" class="side-pane">
    <div (panend)="onPanEnd($event)" (panmove)="onPane($event)" class="header flex-shrink">
      <div class="thumb-container">
        <div class="thumb"></div>
      </div>
      <div class="logo-share">
        <ng-container *ngTemplateOutlet="logo"></ng-container>
        <div class="separator"></div>
        <ng-container *ngTemplateOutlet="shareBtn"></ng-container>
      </div>
      <div class="dispatch-overview">
        <div class="id overflow-container" [attr.title]="dispatchDetails?.orderNumber" i18n>Dispatch #{{dispatchDetails?.orderNumber}}</div>
        <div class="summary">
          <div class="shipper">
            {{dispatchDetails.dispatchFrom}}
            <svg *ngIf="dispatchDetails?.numberOfStops > 1"    width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M19.08 12l-2.323-2.3.707-.7L21 12.5 17.465 16l-.708-.7 2.324-2.3H2v-1h17.08z" fill="#C7C7C7"/></svg>
          </div>
          <div *ngIf="dispatchDetails?.numberOfStops > 1" class="consginee" >
            {{dispatchDetails.dispatchTo}}
          </div>
          <div [class.hide-dot]="hideDot" class="stops">
            <ng-container *ngIf="dispatchDetails?.numberOfStops > 0">
              <div class="separator"></div>
              <br class="line-break"/>{{getShipperStops(dispatchDetails?.numberOfStops)}}
            </ng-container>
          </div>
        </div>
      </div>
      <div class="current-milestone" [ngClass]="{'delayed-summary-box': dispatchDetails?.dispatchSummary.isDelayed}">
        {{dispatchDetails?.dispatchSummary.summary}}
      </div>
    </div>

    <div class="scrollable">
      <div class="steps">
        <div class="heading" i18n>Progress</div>
        <ng-container *ngFor="let dispatchStop of dispatchDetails?.dispatchStops">
          <dispatch-step [ngClass]="{
            'only-pickup': dispatchStop.stopType === 'pickup',
            'not-last-touched': isDispatchDeparted(dispatchStop),
            'only-dropoff': dispatchStop.stopType === 'dropoff',
            'touched': (dispatchStop.status === 'arrived' || dispatchStop.status === 'departed'),
            'inprogress': (dispatchStop.isCurrentLocation && dispatchStop.status !== 'departed') || dispatchStop.status === 'in_progress'}"
            [dispatchStop]="dispatchStop" [showDateTimeStats]="true"></dispatch-step>
        </ng-container>
      </div>

      <div class="info section-border padding-bottom-none"
        *ngIf="dispatchDetails && isProductDetailExists(dispatchDetails.dispatchOrderDetails)">
        <div class="heading" i18n>Details</div>
        <div class="detail-lines">
          <div class="detail-line" *ngIf='dispatchDetails?.dispatchOrderDetails?.product'>
            <label i18n>Product</label>
            <div class="value">{{dispatchDetails.dispatchOrderDetails.product}}</div>
          </div>
          <div class="detail-line" *ngIf='dispatchDetails?.dispatchOrderDetails?.pieces'>
            <label i18n>Pieces</label>
            <div class="value">{{dispatchDetails.dispatchOrderDetails.pieces}}</div>
          </div>
          <div class="detail-line" *ngIf='dispatchDetails?.dispatchOrderDetails?.weight'>
            <label i18n>Weight</label>
            <div class="value">{{dispatchDetails.dispatchOrderDetails.weight}} lbs</div>
          </div>
          <div class="detail-line" *ngIf='dispatchDetails?.dispatchOrderDetails?.volume'>
            <label i18n>Volume</label>
            <div class="value">{{dispatchDetails.dispatchOrderDetails.volume}}</div>
          </div>
        </div>
      </div>

      <div class="info padding-top-none">
        <div class="requirements" *ngIf="dispatchDetails?.dispatchOrderDetails.consigneeComments">
          <label i18n>Accessorial & Requirements</label>
          <div class="value">{{dispatchDetails.dispatchOrderDetails.consigneeComments}}</div>
        </div>
      </div>

      <div class="info section-border" *ngIf="dispatchDetails?.company?.companyLogoExists">
        <ng-container *ngTemplateOutlet="MotiveBottomLogo"></ng-container>
      </div>
    </div>
  </div>

  <div *ngIf="dispatchDetails" class="map">
    <div class="map-info-prompt" *ngIf="!dispatchDetails?.isDispatchStarted && !isDispatchArrivedAtFirstStop(dispatchDetails)" i18n>
      Tracking will begin after the driver arrives at the first stop.
    </div>
    <map #mapComponent class="dispatch-map" [gmapOptions]="mapOptions">
      <map-marker #mapMarker *ngFor="let dispatchStop of dispatchDetails?.dispatchStops"
        [label]="getMapMarkerLabelText(dispatchStop)" [lat]="dispatchStop.dispatchLocation.lat"
        [info]="getMapMarkerInfo(dispatchStop)"
        [lng]="dispatchStop.dispatchLocation.lon" [type]="getMapMarkerLabel(dispatchStop)" [zIndex]="100" [autoZoom]="false">
      </map-marker>
      <map-polyline *ngIf="dispatchDetails" [coords]="dispatchDetails?.vehicleLocations" [autoZoom]="true" zIndex="1" [attr.color]="green40" width="4">
      </map-polyline>
    </map>
  </div>
</div>

<div *ngIf="hideMapView && !isDispatchNotFound && !isLoading" class="dispatch-completed-container">
  <dispatch-completed [dispatchDetails]="dispatchDetails"></dispatch-completed>
</div>

<ng-container *ngIf="isDispatchNotFound && !isLoading">
  <div class="main-header page-not-found">
    <ng-container *ngTemplateOutlet="logo"></ng-container>
  </div>
  <dispatch-not-found></dispatch-not-found>
</ng-container>

<div *ngIf="isLoading" data-e2e="card-loader" class="ui active loader"></div>

<ng-template #logo> <svg class="logo"    width="81" height="24" viewBox="0 0 81 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M44.356 8.158v7.66l3.134-.006v3.185h-6.7V8.156h-2.027V5.052h2.026V.45h3.567v4.604h3.134v3.104h-3.134zM52.566.45v3.175h-.001v.003h-3.559V.45h3.56zM13.751 5.05H9.49L3.12 15.819H0v3.185h4.98l5.213-8.818v8.812h4.204l5.188-8.837v8.837h3.568V5.05h-4.281l-5.12 8.648V5.051zM49.003 5.05h3.567v13.947h-3.567V5.05z" fill="#000"/><path fill-rule="evenodd" clip-rule="evenodd" d="M31.5 4.889h.026c3.838 0 6.89 3.216 6.89 7.135 0 3.919-3.052 7.135-6.89 7.135h-.027c-3.836 0-6.917-3.186-6.917-7.135 0-3.95 3.08-7.135 6.917-7.135zm0 10.702h.026v-.002c1.865 0 3.324-1.594 3.327-3.565 0-1.947-1.49-3.568-3.327-3.568h-.027c-1.89 0-3.35 1.594-3.35 3.568 0 1.973 1.46 3.567 3.35 3.567zM74.614 15.99c1.434 0 2.327-.837 2.57-1.568h3.568c-.135 1.163-1.677 4.734-6.14 4.734-4.03 0-7.008-3.03-7.008-7.142 0-4.03 3.058-7.142 6.898-7.142C78.154 4.872 81 8.064 81 11.96c0 .405-.027.785-.053 1.055h-9.684c.241 1.705 1.27 2.975 3.351 2.975zm-3.237-5.518h6.112c-.383-1.402-1.325-2.435-2.975-2.435-1.73 0-2.736 1.002-3.137 2.435z" fill="#000"/><path d="M61.07 14.176l3.399-9.123v.008h3.8l-5.427 13.936h-3.59L53.855 5.053h3.814l3.4 9.123z" fill="#000"/></svg></ng-template>

<ng-template #shareBtn>
  <button (click)="onShareClick()" class="share-btn">
    <svg    width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.089 6.163a2.5 2.5 0 1 1 .453.891L6.92 9.873a2.504 2.504 0 0 1-.003 1.268l5.622 2.809a2.5 2.5 0 1 1-.451.892l-5.615-2.805a2.5 2.5 0 1 1 .008-3.062l5.608-2.81zM14.5 7a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm-10 5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm8.5 3.5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0z" fill="#757575"/></svg>
  </button>
</ng-template>

<ng-template #MotiveBottomLogo>
  <div class="kt-logo-bottom">
    <svg class="logo"    width="81" height="24" viewBox="0 0 81 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M44.356 8.158v7.66l3.134-.006v3.185h-6.7V8.156h-2.027V5.052h2.026V.45h3.567v4.604h3.134v3.104h-3.134zM52.566.45v3.175h-.001v.003h-3.559V.45h3.56zM13.751 5.05H9.49L3.12 15.819H0v3.185h4.98l5.213-8.818v8.812h4.204l5.188-8.837v8.837h3.568V5.05h-4.281l-5.12 8.648V5.051zM49.003 5.05h3.567v13.947h-3.567V5.05z" fill="#000"/><path fill-rule="evenodd" clip-rule="evenodd" d="M31.5 4.889h.026c3.838 0 6.89 3.216 6.89 7.135 0 3.919-3.052 7.135-6.89 7.135h-.027c-3.836 0-6.917-3.186-6.917-7.135 0-3.95 3.08-7.135 6.917-7.135zm0 10.702h.026v-.002c1.865 0 3.324-1.594 3.327-3.565 0-1.947-1.49-3.568-3.327-3.568h-.027c-1.89 0-3.35 1.594-3.35 3.568 0 1.973 1.46 3.567 3.35 3.567zM74.614 15.99c1.434 0 2.327-.837 2.57-1.568h3.568c-.135 1.163-1.677 4.734-6.14 4.734-4.03 0-7.008-3.03-7.008-7.142 0-4.03 3.058-7.142 6.898-7.142C78.154 4.872 81 8.064 81 11.96c0 .405-.027.785-.053 1.055h-9.684c.241 1.705 1.27 2.975 3.351 2.975zm-3.237-5.518h6.112c-.383-1.402-1.325-2.435-2.975-2.435-1.73 0-2.736 1.002-3.137 2.435z" fill="#000"/><path d="M61.07 14.176l3.399-9.123v.008h3.8l-5.427 13.936h-3.59L53.855 5.053h3.814l3.4 9.123z" fill="#000"/></svg>
  </div>
</ng-template>

<share-tracking-modal (publicShare)="onShareButtonClicked($event)" [isPublicUser]="true" #shareTrackingModal></share-tracking-modal>
